/* =====================================================================
   NO SUGAR – Personalizados 2027 (Custom Meal, Custom Breakfast y calculadora)
   Sustituye a SC Product Options. Requiere: ns-rotation2027.js, ns-rules2027.js
   y ns-shop2027.js cargados antes (solo para la parte de interfaz).
   - Precios: precio de cada variante (porción) del producto del ingrediente.
   - Macros: metafields ns_nutri.* del producto, por 100 g o por pieza.
   - Reglas de la calculadora: ajustes de la sección en el editor del tema.
   La parte de cálculo (NSCustom.calc, solve, totals, buildItems) no usa el DOM
   y se prueba con Node (tests/custom.test.js).
   ===================================================================== */
(function (global) {
  'use strict';

  var C = {};
  var KIND = 'Personalizado';

  /* ---------- Grupos de ingredientes ---------- */
  // key = valor del metafield ns_nutri.grupo. none = texto de la opción "sin" (null = obligatorio).
  // from: el grupo usa productos de otros grupos (solo su porción más chica).
  // showIf: el grupo aparece solo si el ingrediente elegido en otro grupo tiene esa etiqueta.
  C.GROUPS = {
    meal: [
      { key: 'proteina', title: 'Proteína', none: null },
      { key: 'carbohidrato', title: 'Guarnición de carbohidratos', none: 'Sin carbohidratos' },
      { key: 'vegetal', title: 'Guarnición de vegetales', none: 'Sin vegetales' },
      { key: 'extra', title: 'Guarnición extra', none: 'Sin guarnición extra', from: ['carbohidrato', 'vegetal'] }
    ],
    breakfast: [
      { key: 'huevo', title: 'Huevo', none: 'Sin huevo' },
      { key: 'proteina2', title: 'Segunda proteína', none: 'Sin segunda proteína' },
      { key: 'acompanamiento', title: 'Acompañamiento', none: 'Sin acompañamiento' },
      { key: 'relleno', title: 'Relleno del omelette', none: 'Sin relleno', showIf: { group: 'huevo', tag: 'cm-omelette' } },
      { key: 'topping', title: 'Para tus pancakes o waffles', none: 'Sin topping', showIf: { group: 'proteina2', tag: 'cm-topping' } },
      { key: 'fruta', title: 'Fruta', none: 'Sin fruta' }
    ]
  };
  C.MEALS = {
    comida: { label: 'Comida', builder: 'meal', product: 'meal' },
    cena: { label: 'Cena', builder: 'meal', product: 'meal' },
    desayuno: { label: 'Desayuno', builder: 'breakfast', product: 'breakfast' }
  };

  // Reglas por defecto (se sobrescriben con los ajustes de la sección).
  C.DEFAULT_RULES = {
    share: { desayuno: 25, comida: 35, cena: 30 },
    deficitPct: 20, deficitMax: 600, surplusPct: 10,
    protein: { perder: 2.0, mantener: 1.6, ganar: 2.0 },
    fatPct: 28, fatPctLow: 45, carbMaxLow: 100,
    tolerance: 15,
    activity: { sedentaria: 1.2, ligera: 1.375, moderada: 1.55, alta: 1.725, muy_alta: 1.9 }
  };

  /* ---------- Utilidades ---------- */
  function num(v, d) { var n = parseFloat(String(v == null ? '' : v).replace(',', '.')); return isFinite(n) ? n : (d || 0); }
  function round(n) { return Math.round(n); }
  function merge(a, b) {
    var o = {};
    Object.keys(a).forEach(function (k) {
      o[k] = (b && b[k] != null) ? (typeof a[k] === 'object' && !Array.isArray(a[k]) ? merge(a[k], b[k]) : b[k]) : a[k];
    });
    return o;
  }
  C.rules = function (overrides) { return merge(C.DEFAULT_RULES, overrides || {}); };

  /* ---------- Catálogo ---------- */
  // raw: lista que imprime la sección desde la colección de ingredientes (ver ns-custom2027.liquid).
  C.parseCatalog = function (raw) {
    var byGroup = {}, byHandle = {};
    (raw || []).forEach(function (p) {
      var grupo = String(p.grupo || '').trim().toLowerCase();
      if (!grupo) return;
      var piece = /pieza|pza/i.test(String(p.base || ''));
      var sizes = (p.variants || []).map(function (v) {
        var m = /(\d+(?:[.,]\d+)?)/.exec(String(v.title || ''));
        return { q: m ? num(m[1]) : 0, label: String(v.title || ''), variantId: v.id, price: parseInt(v.price, 10) || 0, available: v.available !== false };
      }).filter(function (s) { return s.q > 0; }).sort(function (a, b) { return a.q - b.q; });
      if (!sizes.length) return;
      var item = {
        handle: p.handle, title: p.title, image: p.image || '', grupo: grupo, piece: piece,
        tags: (p.tags || []).map(function (t) { return String(t).toLowerCase(); }),
        m: [num(p.kcal), num(p.proteina), num(p.carbohidratos), num(p.grasa)],
        alergenos: p.alergenos || '', orden: parseInt(p.orden, 10) || 999, sizes: sizes
      };
      (byGroup[grupo] = byGroup[grupo] || []).push(item);
      byHandle[item.handle] = item;
    });
    Object.keys(byGroup).forEach(function (g) {
      byGroup[g].sort(function (a, b) { return a.orden - b.orden || String(a.title).localeCompare(String(b.title), 'es'); });
    });
    return { groups: byGroup, byHandle: byHandle };
  };

  // Ingredientes que ofrece un grupo.
  C.options = function (cat, group) {
    if (group.from) {
      var out = [];
      group.from.forEach(function (g) { (cat.groups[g] || []).forEach(function (it) { out.push(it); }); });
      return out;
    }
    return cat.groups[group.key] || [];
  };
  // Porciones que ofrece un ingrediente dentro de un grupo (las guarniciones extra solo la más chica).
  C.sizesFor = function (item, group) {
    if (!item) return [];
    var list = item.sizes.filter(function (s) { return s.available; });
    return group && group.from ? list.slice(0, 1) : list;
  };
  C.visible = function (group, sel, cat) {
    if (!group.showIf) return true;
    var s = sel[group.showIf.group];
    var it = s && s.handle ? cat.byHandle[s.handle] : null;
    return !!it && it.tags.indexOf(group.showIf.tag) > -1;
  };

  /* ---------- Nutrición y precio ---------- */
  C.nutrition = function (item, q) {
    if (!item) return [0, 0, 0, 0];
    var k = item.piece ? q : q / 100;
    return item.m.map(function (v) { return v * k; });
  };
  // sel: { grupo: { handle, q } }. Devuelve totales, precio (centavos) y líneas elegidas.
  C.totals = function (builder, sel, cat) {
    var tot = [0, 0, 0, 0], price = 0, lines = [];
    C.GROUPS[builder].forEach(function (g) {
      if (!C.visible(g, sel, cat)) return;
      var s = sel[g.key];
      if (!s || !s.handle) return;
      var it = cat.byHandle[s.handle];
      if (!it) return;
      var size = C.sizesFor(it, g).filter(function (x) { return x.q === s.q; })[0];
      if (!size) return;
      var n = C.nutrition(it, size.q);
      tot = tot.map(function (v, i) { return v + n[i]; });
      price += size.price;
      lines.push({ group: g, item: it, size: size, n: n });
    });
    return { kcal: tot[0], p: tot[1], c: tot[2], f: tot[3], price: price, lines: lines };
  };
  C.qtyLabel = function (item, q) {
    if (item && item.piece) return q + (q === 1 ? ' pza' : ' pzas');
    return q + ' g';
  };

  /* ---------- Calculadora (Mifflin-St Jeor) ---------- */
  // input: { sexo: 'h'|'m', edad, peso, altura, actividad (clave de rules.activity), objetivo: perder|mantener|ganar, estilo: balanceado|bajo }
  C.calc = function (input, rules) {
    rules = rules || C.rules();
    var peso = num(input.peso), alt = num(input.altura), edad = num(input.edad);
    if (!(peso > 0 && alt > 0 && edad > 0)) return null;
    var bmr = 10 * peso + 6.25 * alt - 5 * edad + (input.sexo === 'm' ? -161 : 5);
    var factor = rules.activity[input.actividad] || rules.activity.moderada;
    var tdee = bmr * factor;
    var obj = input.objetivo || 'mantener';
    var kcal = obj === 'perder' ? tdee - Math.min(tdee * rules.deficitPct / 100, rules.deficitMax)
      : obj === 'ganar' ? tdee * (1 + rules.surplusPct / 100) : tdee;
    var low = input.estilo === 'bajo';
    var p = peso * (rules.protein[obj] || rules.protein.mantener);
    var f = kcal * (low ? rules.fatPctLow : rules.fatPct) / 100 / 9;
    var c = Math.max(0, (kcal - p * 4 - f * 9) / 4);
    if (low && c > rules.carbMaxLow) { c = rules.carbMaxLow; f = Math.max(0, (kcal - p * 4 - c * 4) / 9); }
    var perMeal = {};
    Object.keys(rules.share).forEach(function (m) {
      var s = rules.share[m] / 100;
      perMeal[m] = { kcal: kcal * s, p: p * s, c: c * s, f: f * s };
    });
    var plan = low ? 'Keto' : obj === 'perder' ? 'Slim' : obj === 'ganar' ? 'Stronger' : 'Healthy';
    return { bmr: bmr, tdee: tdee, kcal: kcal, p: p, c: c, f: f, perMeal: perMeal, plan: plan };
  };

  /* ---------- Porciones sugeridas ---------- */
  function nearest(sizes, v) {
    var best = null;
    sizes.forEach(function (s) { if (!best || Math.abs(s.q - v) < Math.abs(best.q - v)) best = s; });
    return best;
  }
  function pick(cat, sel, key) { var s = sel[key]; return s && s.handle ? cat.byHandle[s.handle] : null; }
  function groupOf(builder, key) { return C.GROUPS[builder].filter(function (g) { return g.key === key; })[0]; }
  function fixQ(cat, sel, builder, key, wanted) {
    var it = pick(cat, sel, key);
    if (!it) return [0, 0, 0, 0];
    var sz = nearest(C.sizesFor(it, groupOf(builder, key)), wanted);
    if (!sz) return [0, 0, 0, 0];
    sel[key].q = sz.q;
    return C.nutrition(it, sz.q);
  }
  function current(cat, sel, builder, key) {
    var it = pick(cat, sel, key);
    return it && sel[key].q ? C.nutrition(it, sel[key].q) : [0, 0, 0, 0];
  }
  // Ajusta las porciones de los ingredientes ya elegidos para acercarse a la meta de la comida.
  // Comida/cena: el carbohidrato cubre los carbohidratos que faltan después de los vegetales;
  // la proteína cubre la proteína que falta. Desayuno: el acompañamiento cubre carbohidratos,
  // el huevo cubre la proteína. Devuelve una copia de sel.
  C.solve = function (builder, sel, cat, goal) {
    var s = JSON.parse(JSON.stringify(sel || {}));
    if (!goal) return s;
    var add = function (a, b) { return a.map(function (v, i) { return v + b[i]; }); };
    if (builder === 'meal') {
      var fixed = add(current(cat, s, builder, 'vegetal'), current(cat, s, builder, 'extra'));
      var carb = pick(cat, s, 'carbohidrato');
      var cn = carb && carb.m[2] > 0 ? fixQ(cat, s, builder, 'carbohidrato', (goal.c - fixed[2]) / carb.m[2] * 100) : current(cat, s, builder, 'carbohidrato');
      var prot = pick(cat, s, 'proteina');
      if (prot && prot.m[1] > 0) fixQ(cat, s, builder, 'proteina', (goal.p - fixed[1] - cn[1]) / prot.m[1] * (prot.piece ? 1 : 100));
    } else {
      var other = add(add(current(cat, s, builder, 'proteina2'), current(cat, s, builder, 'relleno')), add(current(cat, s, builder, 'topping'), current(cat, s, builder, 'fruta')));
      var ac = pick(cat, s, 'acompanamiento');
      var an = ac && ac.m[2] > 0 ? fixQ(cat, s, builder, 'acompanamiento', (goal.c - other[2]) / ac.m[2] * (ac.piece ? 1 : 100)) : current(cat, s, builder, 'acompanamiento');
      var egg = pick(cat, s, 'huevo');
      if (egg && egg.m[1] > 0) fixQ(cat, s, builder, 'huevo', (goal.p - other[1] - an[1]) / egg.m[1] * (egg.piece ? 1 : 100));
    }
    return s;
  };

  // ¿Está dentro de la meta? Se mide en proteína y carbohidratos (lo que controlan las porciones).
  C.fit = function (t, goal, tolerancePct) {
    if (!goal) return { ok: true, noGoal: true };
    var tol = (tolerancePct || 15) / 100;
    var dp = goal.p ? (t.p - goal.p) / goal.p : 0;
    var dc = goal.c >= 15 ? (t.c - goal.c) / goal.c : 0;
    return { ok: Math.abs(dp) <= tol && Math.abs(dc) <= tol, dp: t.p - goal.p, dc: t.c - goal.c, dk: t.kcal - goal.kcal };
  };

  // ¿Se puede agregar? Comida/cena piden proteína; desayuno pide al menos un ingrediente.
  C.isComplete = function (builder, t) {
    if (!t.lines.length) return false;
    if (builder === 'meal') return t.lines.some(function (l) { return l.group.key === 'proteina'; });
    return true;
  };

  /* ---------- Carrito ---------- */
  C.newId = function () { return 'cm' + Date.now().toString(36).slice(-5) + Math.random().toString(36).slice(2, 5); };
  // Líneas para /cart/add.js: 1 línea "platillo" (producto Custom Meal o Custom Breakfast a $0, con todo legible)
  // + 1 línea por ingrediente (lleva el precio). Todas comparten _ns_cm y la misma cantidad.
  // o: { meal: 'comida'|'cena'|'desayuno', dishVariantId, qty, week: { iso, id, monday }, gid, entrega, sinSal }
  C.buildItems = function (t, o) {
    var meal = C.MEALS[o.meal];
    var name = (meal.product === 'breakfast' ? 'Custom Breakfast' : 'Custom Meal');
    var label = name + ' · ' + meal.label + ' #' + String(o.gid).slice(-4).toUpperCase();
    var base = { 'Tipo de compra': KIND, Semana: o.week.iso, 'Semana ID': o.week.id, Menu: KIND, Entrega: o.entrega || '' };
    var dish = {};
    Object.keys(base).forEach(function (k) { dish[k] = base[k]; });
    dish.Platillo = label;
    t.lines.forEach(function (l) { dish[l.group.title] = l.item.title + ' ' + C.qtyLabel(l.item, l.size.q); });
    if (o.sinSal) dish['Sin sal'] = 'Sí'; // la cocina lo prepara sin sal añadida (28 oct 2026)
    // Un solo campo para no chocar con el nombre del grupo "Proteína".
    dish.Macros = round(t.kcal) + ' kcal · proteína ' + round(t.p) + ' g · carbohidratos ' + round(t.c) + ' g · grasa ' + round(t.f) + ' g';
    dish._ns_cm = o.gid; dish._ns_cm_rol = 'platillo'; dish._ns_cm_n = String(t.lines.length);
    var items = [{ id: o.dishVariantId, quantity: o.qty, properties: dish }];
    t.lines.forEach(function (l) {
      var p = {};
      Object.keys(base).forEach(function (k) { p[k] = base[k]; });
      p.Platillo = label;
      p._ns_cm = o.gid; p._ns_cm_rol = 'ingrediente';
      items.push({ id: l.size.variantId, quantity: o.qty, properties: p });
    });
    return items;
  };

  global.NSCustom = C;
  if (typeof module !== 'undefined' && module.exports) module.exports = C;

  /* =====================================================================
     Interfaz (solo navegador)
     ===================================================================== */
  C.mount = function (root, cfg) {
    var S = global.NSShop, Rl = global.NSRules, esc = S.esc;
    var cat = C.parseCatalog(cfg.catalog);
    var rules = C.rules(cfg.rules);
    var K_PROFILE = 'ns2_cm_profile', K_PREFS = 'ns2_cm_prefs';
    var profile = S.pref.get(K_PROFILE, null);
    var prefs = S.pref.get(K_PREFS, {}) || {};
    var ctx = S.ctx();
    var st = { meal: C.MEALS[prefs.meal] ? prefs.meal : 'comida', weekId: prefs.weekId || null, qty: 1, busy: false, cart: { items: [] }, sel: {}, sinSal: !!S.pref.get('ns2c_sinsal', false) };
    var order;
    function $(q) { return root.querySelector(q); }

    // Selección inicial: primer ingrediente de cada grupo obligatorio y una porción media.
    function defaults(builder) {
      var sel = {};
      C.GROUPS[builder].forEach(function (g) {
        var opts = C.options(cat, g);
        if (g.none === null && opts.length) {
          var sz = C.sizesFor(opts[0], g);
          sel[g.key] = { handle: opts[0].handle, q: sz.length ? sz[Math.floor((sz.length - 1) / 2)].q : 0 };
        } else sel[g.key] = { handle: null, q: 0 };
      });
      return sel;
    }
    Object.keys(C.MEALS).forEach(function (m) { st.sel[m] = defaults(C.MEALS[m].builder); });

    function builder() { return C.MEALS[st.meal].builder; }
    function goal() { var r = profile && C.calc(profile, rules); return r ? r.perMeal[st.meal] : null; }
    function weeks() { return ctx.alcWeeks; }
    function week() {
      var w = Rl.findWeek(weeks(), st.weekId);
      if (!w) { w = weeks()[0]; st.weekId = w.id; }
      return w;
    }
    function savePrefs() { S.pref.set(K_PREFS, { meal: st.meal, weekId: st.weekId }); }

    /* ----- Calculadora ----- */
    function renderCalc() {
      var p = profile || { sexo: 'm', edad: '', peso: '', altura: '', actividad: 'moderada', objetivo: 'perder', estilo: 'balanceado' };
      var r = profile && C.calc(profile, rules);
      var seg = function (name, opts) {
        return '<div class="ns2c-seg" role="radiogroup">' + opts.map(function (o) {
          return '<label><input type="radio" name="' + name + '" value="' + o[0] + '"' + (p[name] === o[0] ? ' checked' : '') + '><span>' + o[1] + '</span></label>';
        }).join('') + '</div>';
      };
      $('[data-box="calc"]').innerHTML =
        '<form class="ns2c-form" data-calc novalidate>' +
        '<div class="ns2c-f ns2c-full"><span class="ns2c-label">Sexo</span>' + seg('sexo', [['m', 'Mujer'], ['h', 'Hombre']]) + '</div>' +
        '<label class="ns2c-f"><span class="ns2c-label">Edad</span><input id="ns2c-edad" name="edad" type="number" inputmode="numeric" min="15" max="90" value="' + esc(p.edad) + '" placeholder="años"></label>' +
        '<label class="ns2c-f"><span class="ns2c-label">Peso</span><input id="ns2c-peso" name="peso" type="number" inputmode="decimal" min="35" max="250" step="0.5" value="' + esc(p.peso) + '" placeholder="kg"></label>' +
        '<label class="ns2c-f"><span class="ns2c-label">Estatura</span><input id="ns2c-altura" name="altura" type="number" inputmode="numeric" min="130" max="220" value="' + esc(p.altura) + '" placeholder="cm"></label>' +
        '<label class="ns2c-f ns2c-full"><span class="ns2c-label">Actividad</span><select id="ns2c-act" name="actividad">' +
        [['sedentaria', 'Sedentaria (oficina, sin ejercicio)'], ['ligera', 'Ligera (1 a 3 entrenamientos por semana)'], ['moderada', 'Moderada (3 a 5 entrenamientos)'], ['alta', 'Alta (6 a 7 entrenamientos)'], ['muy_alta', 'Muy alta (doble sesión o trabajo físico)']]
          .map(function (o) { return '<option value="' + o[0] + '"' + (p.actividad === o[0] ? ' selected' : '') + '>' + o[1] + '</option>'; }).join('') + '</select></label>' +
        '<div class="ns2c-f ns2c-full"><span class="ns2c-label">Objetivo</span>' + seg('objetivo', [['perder', 'Bajar grasa'], ['mantener', 'Mantener'], ['ganar', 'Ganar músculo']]) + '</div>' +
        '<div class="ns2c-f ns2c-full"><span class="ns2c-label">Estilo</span>' + seg('estilo', [['balanceado', 'Balanceado'], ['bajo', 'Bajo en carbohidratos']]) + '</div>' +
        '</form>' +
        '<div class="ns2c-result" aria-live="polite">' + (r ? resultHtml(r) :
          '<p class="ns2-small">Llena tus datos para ver tus calorías y macros. Se guardan solo en este dispositivo.</p>') + '</div>';
    }
    function resultHtml(r) {
      var row = function (k, label) { var m = r.perMeal[k]; return '<tr><td>' + label + '</td><td>' + round(m.kcal) + '</td><td>' + round(m.p) + ' g</td><td>' + round(m.c) + ' g</td><td>' + round(m.f) + ' g</td></tr>'; };
      return '<div class="ns2c-kcal"><b>' + round(r.kcal).toLocaleString('es-MX') + '</b><span>kcal al día<br><small>Gasto estimado ' + round(r.tdee).toLocaleString('es-MX') + ' kcal</small></span></div>' +
        '<div class="ns2c-macros"><div><i class="ns2c-dot is-p"></i>Proteína<b>' + round(r.p) + ' g</b></div><div><i class="ns2c-dot is-c"></i>Carbohidratos<b>' + round(r.c) + ' g</b></div><div><i class="ns2c-dot is-f"></i>Grasa<b>' + round(r.f) + ' g</b></div></div>' +
        '<div class="ns2c-tablewrap"><table class="ns2c-table"><thead><tr><th>Por comida</th><th>kcal</th><th>Prot</th><th>Carb</th><th>Grasa</th></tr></thead><tbody>' +
        row('desayuno', 'Desayuno') + row('comida', 'Comida') + row('cena', 'Cena') + '</tbody></table></div>' +
        '<div class="ns2-note ns2-note--ok"><p class="ns2-note__text"><strong>Te recomendamos el menú ' + esc(r.plan) + '</strong> o armar tus platillos aquí abajo con las porciones ajustadas a ti.' +
        (cfg.links && cfg.links.planes ? ' <a href="' + esc(cfg.links.planes) + '">Ver planes</a>' : '') + '</p></div>';
    }
    function readCalc() {
      var f = $('[data-calc]');
      if (!f) return;
      var val = function (n) { var el = f.querySelector('[name="' + n + '"]:checked') || f.querySelector('[name="' + n + '"]'); return el ? el.value : ''; };
      profile = { sexo: val('sexo'), edad: val('edad'), peso: val('peso'), altura: val('altura'), actividad: val('actividad'), objetivo: val('objetivo'), estilo: val('estilo') };
      if (C.calc(profile, rules)) S.pref.set(K_PROFILE, profile);
      $('.ns2c-result').innerHTML = C.calc(profile, rules) ? resultHtml(C.calc(profile, rules)) : '<p class="ns2-small">Completa edad, peso y estatura.</p>';
      renderSummary();
    }

    /* ----- Constructor ----- */
    function renderTabs() {
      $('[data-box="meals"]').innerHTML = Object.keys(C.MEALS).map(function (m) {
        return '<button type="button" class="ns2-chip" data-meal="' + m + '" aria-pressed="' + (st.meal === m) + '">' + S.icon(S.MEAL_ICONS[m]) + C.MEALS[m].label + '</button>';
      }).join('');
    }
    function renderWeeks() {
      var w = week();
      $('[data-box="weeks"]').innerHTML = weeks().map(function (x) {
        return '<button type="button" class="ns2-week" data-week="' + x.id + '" aria-pressed="' + (x.id === w.id) + '">' +
          '<span><span class="ns2-week__date">' + Rl.weekLabel(x.monday) + '</span><span class="ns2-week__num">Semana ' + x.iso + '</span></span></button>';
      }).join('');
    }
    function renderGroups() {
      var b = builder(), sel = st.sel[st.meal], h = '';
      C.GROUPS[b].forEach(function (g) {
        if (!C.visible(g, sel, cat)) return;
        var opts = C.options(cat, g), cur = sel[g.key];
        if (!opts.length) return;
        h += '<fieldset class="ns2c-group"><legend class="ns2-h2">' + esc(g.title) + '</legend><div class="ns2c-opts">';
        if (g.none !== null) h += '<button type="button" class="ns2c-opt" data-g="' + g.key + '" data-h="" aria-pressed="' + !cur.handle + '"><b>' + esc(g.none) + '</b></button>';
        opts.forEach(function (it) {
          var unit = it.piece ? 'por pieza' : 'por 100 g';
          h += '<button type="button" class="ns2c-opt" data-g="' + g.key + '" data-h="' + esc(it.handle) + '" aria-pressed="' + (cur.handle === it.handle) + '">' +
            (it.image ? '<img src="' + esc(S.img(it.image, 160)) + '" alt="" loading="lazy" width="48" height="48">' : '') +
            '<span><b>' + esc(it.title) + '</b><small>' + round(it.m[0]) + ' kcal · ' + (+it.m[1].toFixed(1)) + ' g prot ' + unit + '</small></span></button>';
        });
        h += '</div>';
        var it2 = cur.handle ? cat.byHandle[cur.handle] : null;
        if (it2) {
          var sizes = C.sizesFor(it2, g);
          h += '<div class="ns2-chips" role="group" aria-label="Porción de ' + esc(it2.title) + '">' + sizes.map(function (sz) {
            return '<button type="button" class="ns2-chip" data-g="' + g.key + '" data-q="' + sz.q + '" aria-pressed="' + (cur.q === sz.q) + '">' +
              esc(C.qtyLabel(it2, sz.q)) + '<span class="ns2c-pr">' + S.money(sz.price) + '</span></button>';
          }).join('') + '</div>';
          if (it2.alergenos) h += '<p class="ns2-small">Contiene: ' + esc(it2.alergenos) + '</p>';
        }
        h += '</fieldset>';
      });
      $('[data-box="groups"]').innerHTML = h || S.emptyBox('Aún no hay ingredientes', 'Vuelve más tarde.');
    }
    function bar(label, val, tgt, cls, unit) {
      var max = Math.max(tgt * 1.5, val, 1);
      return '<div class="ns2c-bar"><div class="ns2c-bar__head"><span>' + label + '</span><span>' + round(val) + (tgt ? ' / ' + round(tgt) : '') + ' ' + unit + '</span></div>' +
        '<div class="ns2c-track"><i class="' + cls + '" style="width:' + (val / max * 100).toFixed(1) + '%"></i>' +
        (tgt ? '<em style="left:' + (tgt / max * 100).toFixed(1) + '%"></em>' : '') + '</div></div>';
    }
    function renderSummary() {
      var b = builder(), t = C.totals(b, st.sel[st.meal], cat), g = goal(), fit = C.fit(t, g, rules.tolerance);
      var w = week();
      var lines = t.lines.map(function (l) {
        return '<div class="ns2-row"><span>' + esc(l.item.title) + ' · ' + esc(C.qtyLabel(l.item, l.size.q)) + '</span><span>' + S.money(l.size.price) + '</span></div>';
      }).join('');
      var msg;
      if (fit.noGoal) msg = '<p class="ns2-small">Llena la calculadora para comparar con tu objetivo.</p>';
      else if (fit.ok) msg = '<div class="ns2-note ns2-note--ok"><p class="ns2-note__text"><strong>Dentro de tu objetivo para ' + C.MEALS[st.meal].label.toLowerCase() + '.</strong>' +
        (fit.dk < -g.kcal * 0.12 ? ' Te quedan ' + round(-fit.dk) + ' kcal para aceite, aderezo o colación.' : '') + '</p></div>';
      else {
        var parts = [];
        if (Math.abs(fit.dp) > g.p * rules.tolerance / 100) parts.push('proteína ' + (fit.dp > 0 ? '+' : '') + round(fit.dp) + ' g');
        if (g.c >= 15 && Math.abs(fit.dc) > g.c * rules.tolerance / 100) parts.push('carbohidratos ' + (fit.dc > 0 ? '+' : '') + round(fit.dc) + ' g');
        msg = '<div class="ns2-note ns2-note--warn"><p class="ns2-note__text"><strong>Fuera de tu objetivo:</strong> ' + parts.join(', ') + '.</p></div>';
      }
      var ok = C.isComplete(b, t);
      $('[data-box="sum"]').innerHTML =
        '<div class="ns2c-sum__top"><p class="ns2-small">' + esc(C.MEALS[st.meal].label) + ' · ' + esc(Rl.weekShort(w.monday)) + '</p>' +
        '<p class="ns2c-price">' + S.money(t.price) + '<small> por platillo</small></p></div>' +
        (lines || '<p class="ns2-small">Elige tus ingredientes.</p>') +
        '<div class="ns2c-bars">' + bar('Calorías', t.kcal, g && g.kcal, 'is-k', 'kcal') + bar('Proteína', t.p, g && g.p, 'is-p', 'g') +
        bar('Carbohidratos', t.c, g && g.c, 'is-c', 'g') + bar('Grasa', t.f, g && g.f, 'is-f', 'g') + '</div>' + msg +
        (g ? '<button type="button" class="ns2-btn ns2-btn--outline ns2-btn--block" data-auto>' + S.icon('spark') + 'Ajustar porciones a mi objetivo</button>' : '') +
        '<label class="ns2c-sinsal"><input type="checkbox" data-sinsal' + (st.sinSal ? ' checked' : '') + '><span><strong>Preparar sin sal</strong>Cocinamos tus ingredientes sin sal añadida.</span></label>' +
        '<div class="ns2c-qtyrow"><span>Cuántos iguales</span><div class="ns2-qty" role="group" aria-label="Cantidad de platillos iguales">' +
        '<button type="button" data-qty="-1" aria-label="Uno menos"' + (st.qty <= 1 ? ' disabled' : '') + '>−</button><output>' + st.qty + '</output>' +
        '<button type="button" data-qty="1" aria-label="Uno más"' + (st.qty >= 14 ? ' disabled' : '') + '>+</button></div></div>' +
        '<button type="button" class="ns2-btn ns2-btn--primary ns2-btn--block" data-add' + (ok ? '' : ' disabled') + '>Agregar ' + (st.qty > 1 ? st.qty + ' platillos · ' + S.money(t.price * st.qty) : 'al pedido') + '</button>' +
        '<p class="ns2-small">Calorías y macros estimados con porciones cocidas; pueden variar ±10 %. Te llega ' + esc(Rl.deliveryPhrase(w.monday)) + '.</p>';
    }
    function renderAll() { renderTabs(); renderWeeks(); renderGroups(); renderSummary(); }

    /* ----- Acciones ----- */
    async function add() {
      if (st.busy) return;
      var b = builder(), t = C.totals(b, st.sel[st.meal], cat);
      if (!C.isComplete(b, t)) return;
      var dish = cfg.products[C.MEALS[st.meal].product];
      if (!dish || !dish.variantId) { S.toast('Este platillo no está disponible por ahora.'); return; }
      st.busy = true;
      try {
        var cart = await S.api.cart();
        if (Rl.conflictFor(KIND, cart)) { S.mixDialog(KIND, cart, function () { order.refresh().then(add); }, order.open); return; }
        var w = week();
        var items = C.buildItems(t, { meal: st.meal, dishVariantId: dish.variantId, qty: st.qty, week: w, gid: C.newId(), entrega: Rl.deliveryWindow(w.monday), sinSal: st.sinSal });
        await S.api.addMany(items);
        await order.refresh();
        S.toast(st.qty > 1 ? 'Agregamos ' + st.qty + ' platillos a tu pedido.' : 'Agregamos tu platillo a tu pedido.', true);
        st.qty = 1;
        renderSummary();
      } catch (e) { S.toast(S.friendlyError(e, 'add')); order.refresh(); }
      finally { st.busy = false; }
    }

    root.addEventListener('input', function (e) { if (e.target.closest('[data-calc]')) readCalc(); });
    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-calc]')) readCalc();
      if (e.target.matches('[data-sinsal]')) { st.sinSal = e.target.checked; S.pref.set('ns2c_sinsal', st.sinSal); }
    });
    root.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b || b.disabled) return;
      var sel = st.sel[st.meal];
      if (b.hasAttribute('data-meal')) { st.meal = b.getAttribute('data-meal'); savePrefs(); renderAll(); return; }
      if (b.hasAttribute('data-week')) { st.weekId = b.getAttribute('data-week'); savePrefs(); renderWeeks(); renderSummary(); return; }
      if (b.hasAttribute('data-qty')) { st.qty = Math.max(1, Math.min(14, st.qty + parseInt(b.getAttribute('data-qty'), 10))); renderSummary(); return; }
      if (b.hasAttribute('data-auto')) { st.sel[st.meal] = C.solve(builder(), sel, cat, goal()); renderGroups(); renderSummary(); return; }
      if (b.hasAttribute('data-add')) { add(); return; }
      var gk = b.getAttribute('data-g');
      if (!gk || !sel[gk]) return;
      var g = groupOf(builder(), gk);
      if (b.hasAttribute('data-q')) { sel[gk].q = parseFloat(b.getAttribute('data-q')); }
      else {
        var h = b.getAttribute('data-h') || null;
        sel[gk].handle = h;
        var sizes = h ? C.sizesFor(cat.byHandle[h], g) : [];
        if (!sizes.some(function (s) { return s.q === sel[gk].q; })) sel[gk].q = sizes.length ? sizes[Math.floor((sizes.length - 1) / 2)].q : 0;
      }
      renderGroups(); renderSummary();
    });

    function status(cart, v) {
      var s = v ? v.summary : Rl.summarize(cart, ctx.weeks);
      if (v && v.ok) return { msg: 'Tu pedido está listo', sub: 'Puedes pagar o seguir agregando.', percent: 100 };
      var issue = v && v.issues.filter(function (i) { return i.type !== 'empty'; })[0];
      if (issue) return { msg: issue.message, sub: '', percent: Math.min(100, (s.custom.qty || 0) * 100 / Rl.MIN_ALC) };
      return { msg: 'Arma tu platillo', sub: 'Mínimo ' + Rl.MIN_ALC + ' platillos por semana entre a la carta y personalizados.', percent: 0 };
    }
    order = S.mountOrder({ status: status, onChange: function (cart) { st.cart = cart; ctx = S.ctx(); } });

    renderCalc();
    renderAll();
    order.refresh();
  };
})(typeof window !== 'undefined' ? window : globalThis);
